import { EntityType } from '@/types/document';

/**
 * Entity types whose documents can be exposed in the investor portal.
 * FUND / PORTFOLIO_COMPANY docs are visible to all fund investors; INVESTOR
 * docs are visible only to that specific investor (enforced by the portal
 * query in backend/app/portal/documents/services/document_service.py).
 */
export function supportsInvestorVisibility(entityType: EntityType): boolean {
  return (
    entityType === EntityType.FUND ||
    entityType === EntityType.PORTFOLIO_COMPANY ||
    entityType === EntityType.INVESTOR
  );
}

/** The user-facing wording of the visibility toggle and its menu actions. */
interface InvestorVisibilityLabels {
  toggleLabel: string;
  toggleDescription: string;
  showAction: string;
  hideAction: string;
}

/**
 * Wording for the visibility toggle/menu, tailored to the entity type: an
 * investor document is shown to that one investor, whereas a fund or
 * portfolio-company document is shown to every investor in the fund.
 */
export function getInvestorVisibilityLabels(
  entityType: EntityType
): InvestorVisibilityLabels {
  if (entityType === EntityType.INVESTOR) {
    return {
      toggleLabel: 'Visible to this investor',
      toggleDescription:
        'Allow this investor to view and download this document in the portal',
      showAction: 'Show to investor',
      hideAction: 'Hide from investor',
    };
  }
  return {
    toggleLabel: 'Visible to Investors',
    toggleDescription:
      'Allow investors to view and download these documents in the investor portal',
    showAction: 'Show to Investors',
    hideAction: 'Hide from Investors',
  };
}
